import classNames from 'classnames';
import type { ProgramMember } from 'models';
import { Avatar, Button, CheckLineIcon, Col, Delete2LineIcon, Link, QuestionLineIcon, Row, Text } from 'ui';
import { useConfirmDeleteProgramMember } from '../hooks';

type P = {
  member: ProgramMember;
  programId: string;
  programName: string;
};

const MemberRow = ({ member, programId, programName }: P) => {
  const { confirmDeleteMember, contextHolder, isLoading } = useConfirmDeleteProgramMember();

  return (
    <>
      <Row align="middle" className="program-member-row" gutter={['ms', 0]}>
        <Col>
          <Link to={`/members/${member.id}`}>
            <Avatar photo={member.profilePhoto?.url}>{member.fullName}</Avatar>
            <span
              className={classNames('program-member-row__status-icon', {
                'program-member-row__status-icon--joined': member.joined,
              })}
            >
              {member.joined ? (
                <CheckLineIcon className="program-member-row__status-icon-glyph" size="extra-extra-small" />
              ) : (
                <QuestionLineIcon className="program-member-row__status-icon-glyph" size="extra-extra-small" />
              )}
            </span>
          </Link>
        </Col>

        <Col flex="1">
          <Row align="middle" className="program-member-row__content" justify="space-between">
            <Col>
              <Text data-test-id="member_name">{member.fullName}</Text>
            </Col>
            <Button
              danger
              icon={<Delete2LineIcon />}
              loading={isLoading}
              onClick={() => {
                confirmDeleteMember({
                  member,
                  programId,
                  programName,
                });
              }}
              type="link-primary"
            />
          </Row>
        </Col>
      </Row>
      {contextHolder}
    </>
  );
};

export default MemberRow;
